import { useCallback, useEffect } from 'react'
import { Box, Container, Grid } from '@mui/material'
import { useShallow } from 'zustand/shallow'

import { usePersistStore } from '@/store/persist'

const GridHelper = () => {
  const [showGrid, setShowGrid] = usePersistStore(
    useShallow((state) => [state.showGrid, state.setShowGrid])
  )

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.shiftKey && event.key === 'G') setShowGrid(!showGrid)
    },
    [showGrid, setShowGrid]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  return showGrid ? (
    <Box
      sx={{
        pointerEvents: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200
      }}
    >
      {/* Horizontal center line */}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: '50%',
          width: '100%',
          height: '0.1rem',
          bgcolor: 'rgba(255,0,0,0.3)',
          transform: 'translateY(-50%)'
        }}
      />
      {/* Vertical center line */}
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: 0,
          height: '100%',
          width: '0.1rem',
          bgcolor: 'rgba(255,0,0,0.3)',
          transform: 'translateX(-50%)'
        }}
      />
      <Container sx={{ height: '100%' }}>
        <Grid container sx={{ height: '100%' }}>
          {Array.from({ length: 12 }).map((_, index) => (
            <Grid size={1} key={index} sx={{ height: '100%' }}>
              <Box sx={{ height: '100%', bgcolor: 'rgba(255,0,0,0.1)' }} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  ) : null
}

export default GridHelper
